import { createSvgIcon } from '@material-ui/core';

// Google Font Icon https://fonts.google.com/icons?selected=Material+Symbols+Outlined:manage_search:FILL@1;wght@400;GRAD@0;opsz@24&icon.query=search&icon.style=Outlined&icon.size=24&icon.color=%23e3e3e3
export const ManageSearchIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
    fill="currentColor"
  >
    <path d="M80-200v-80h400v80H80Zm0-200v-80h200v80H80Zm0-200v-80h200v80H80Zm744 400L670-354q-24 17-52.5 25.5T560-320q-83 0-141.5-58.5T360-520q0-83 58.5-141.5T560-720q83 0 141.5 58.5T760-520q0 29-8.5 57.5T726-410l154 154-56 56ZM560-400q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35Z" />
  </svg>,
  'ManageSearchIcon',
);
